import React, { useEffect } from "react";
import { Box, Button, Typography } from "@mui/material";
import InfoComponent from "../../components/InfoComponent";
import { useDispatch, useSelector } from "react-redux";
import { fetchPanelList } from "../../features/panels/panelsSlice";
import { useParams } from "react-router-dom";
import SendIcon from "@mui/icons-material/Send";
import { useState } from "react";
import Loader from "../../components/Loader";
import LanguageSelector from "../../components/LanguageSelector";
import {
  fetchcomicTitle,
  selectComicSubTitle,
  selectComicTitle,
  selectComicTitleStatus,
} from "../../features/comicTitle/comicTitleSlice";
import TranslationPanels from "../../components/TranslationPanels";
import { currentSelectedLanguage } from "../../features/selectedLanguage/languageSlice";
import DownloadIcon from "@mui/icons-material/Download";
import { downloadPost } from "../../api/downloadPost";
import {submitJobForEditing} from "../../api/submitForEditing";
import { retryTranslationPost } from "../../api/submitJobPost";

const TranslationId = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [isUpdated, setIsUpdated] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);

  const [isUpdatedComicTitle, setIsUpdatedComicTitle] = useState(false);
  const lang = useSelector(currentSelectedLanguage);
  const panelStatus = useSelector((state) => state.panels.status);
  const comicTitleStatus = useSelector(selectComicTitleStatus);
  const comicSubTitle = useSelector(selectComicSubTitle);
  const comicTitle = useSelector(selectComicTitle);

  useEffect(() => {
    if (panelStatus === "idle" || !isUpdated) {
      dispatch(fetchPanelList(id));
      setIsUpdated(true);
    }
  }, [panelStatus, dispatch, isUpdated, id]);

  useEffect(() => {
    if (comicTitleStatus!=="loading" &&(comicTitleStatus === "idle" || !isUpdatedComicTitle)) {
      dispatch(fetchcomicTitle(id));
      setIsUpdatedComicTitle(true);
    }
  }, [comicTitleStatus, dispatch, id, isUpdatedComicTitle]);
  
    const handleSubmit = async () => {
      try{
        const response = await submitJobForEditing(id);
        alert("Successfully submitted for editing!");
      }
      catch(error)
      {
        alert("Failed to submit for editing. Please try again.");
      }
    };

  if (panelStatus !== "succeeded" && comicTitleStatus !== "succeeded") {
    return <Loader />;
  } else {
    return (
      <>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Box>
            <Typography variant="h6" mb="3px">
              Translation
            </Typography>
            <Box sx={{ display: "flex" }}>
              <Typography variant="h4" fontWeight="bold">
                {comicTitle} / {comicSubTitle}
              </Typography>
              <InfoComponent />
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "20px",
            }}
          >
            <LanguageSelector />
            <Button
              variant="contained"
              size="small"
              sx={{ padding: "10px", borderRadius: "10px" }}
              onClick={async () => {
                try {
                  await retryTranslationPost(id);
                  alert("Translation retry triggered.");
                } catch (e) {
                  alert("Retry failed. Please try again.");
                }
              }}
            >
              Retry Translation
            </Button>
            <Button
              variant="outlined"
              endIcon={<DownloadIcon />}
              size="small"
              sx={{ padding: "10px", borderRadius: "10px" }}
              disabled={isDisabled}
              onClick={async () => {
                try {
                  setIsDisabled(true);
                  
                  // Download translation first
                  await downloadPost("translation", id, lang);
                  
                  // Then download extraction
                  await downloadPost("extraction", id);
                  
                } catch (error) {
                  console.error("Download failed:", error);
                } finally {
                  setIsDisabled(false);
                }
              }}
            >
              Download Results
            </Button>
              <Button
                variant="outlined"
                endIcon={<SendIcon />}
                size="small"
                sx={{ padding: "10px", borderRadius: "10px" }}
                onClick={handleSubmit}
              >
                Submit for Editing
              </Button>
          </Box>
        </Box>
        <TranslationPanels />
      </>
    );
  }
};

export default TranslationId;
